module.exports = __webpack_public_path__ + "static/media/sociana.305ea25f.webp";